<div class="container-fluid">
  <div class="row">
    <div class="col-12 p-3">
      <h5>Manage Excess Payments</h5>
      <hr />
      <mat-checkbox [(ngModel)]="showHistory"
        >Open Transfer History</mat-checkbox
      >
      <mat-checkbox
        matTooltip="Use this option if you want to credit the excess payment back to your own student account."
        [(ngModel)]="transferToSelf"
        (change)="onTransferToSelfChange($event)"
      >
        Transfer to Self
      </mat-checkbox>

      <div class="row pl-3" *ngIf="showHistory">
        <p *ngIf="transferHistory.length == 0">
          <b>No payment transfer made yet, either by you, or to you.</b>
        </p>
        <table
          *ngIf="transferHistory.length > 0"
          class="col-12 table-stried table-hover"
          style="font-size: 13px"
        >
          <tr>
            <th>Sender</th>
            <th>Recipient</th>
            <th>Amount</th>
            <th>Status</th>
            <th *ngIf="allowPaymentTransfer == 1">Action</th>
          </tr>
          <tr *ngFor="let transfer of transferHistory">
            <td>{{ transfer.sender_id }}</td>
            <td>{{ transfer.recipient_id }}</td>
            <td>{{ transfer.amount | currency : "NGN" : "symbol-narrow" }}</td>
            <td>
              <span class="badge badge-warning" *ngIf="transfer.status == 0"
                >pending</span
              >
              <span class="badge badge-success" *ngIf="transfer.status == 1"
                >accepted</span
              >
              <span class="badge badge-danger" *ngIf="transfer.status == 2"
                >rejected</span
              >
            </td>
            <td>
              <div *ngIf="transfer.sender_id == this.originalID">
                <button
                  class="btn btn-danger"
                  *ngIf="allowPaymentTransfer == 1"
                  [disabled]="transfer.status != 0"
                  (click)="deleteTransfer(transfer)"
                >
                  Delete Transfer
                </button>
              </div>
              <div *ngIf="transfer.recipient">
                <!-- {{transfer | json}} -->
                <button
                  class="btn btn-success btn-sm mr-2"
                  *ngIf="allowPaymentTransfer == 'STUDENT'"
                  [matMenuTriggerFor]="transfermenu"
                  [disabled]="transfer.status != '0'"
                >
                  Accept Transfer
                </button>
                <mat-menu #transfermenu="matMenu">
                  <div class="p-2 row">
                    <div class="col-12 mb-2">
                      <label
                        class="mr-sm-2 sr-only"
                        for="inlineFormCustomSelect"
                        >Select Invoice:</label
                      >
                      <select
                        class="custom-select mr-sm-2"
                        [(ngModel)]="invoiceID"
                        id="inlineFormCustomSelect"
                        (click)="$event.stopPropagation()"
                      >
                        <!-- <option selected>Choose...</option> -->
                        <option
                          *ngFor="let pay of paymentHistory"
                          title="{{ pay.category }} - {{ pay.name }} - {{
                            pay.tag
                          }}"
                          [value]="pay.invoice_id"
                        >
                          {{ pay.category | uppercase }} -
                          {{ pay.name | uppercase }} -
                          {{ pay.tag | uppercase }} - {{ pay.term | uppercase }}
                        </option>
                      </select>
                    </div>
                    <div class="col-12">
                      <button
                        class="btn btn-danger btn-block"
                        (click)="transferAction(transfer, 1)"
                      >
                        Confirm Acceptance
                      </button>
                    </div>
                  </div>
                </mat-menu>
                <button
                  *ngIf="allowPaymentTransfer == 'STUDENT'"
                  class="btn btn-danger btn-sm"
                  [disabled]="transfer.status != '0'"
                  (click)="transferAction(transfer, 2)"
                >
                  Reject Transfer
                </button>
              </div>
              <div *ngIf="!transfer.recipient">
                <span class="badge badge-info"
                  >You initiated this payment transfer</span
                >
              </div>
            </td>
          </tr>
        </table>
      </div>
      <mat-accordion
        class="col-12"
        *ngIf="paymentHistory.length > 0 && !showHistory"
      >
        <mat-expansion-panel
          *ngFor="let pay of paymentHistory"
          (opened)="onPanelOpened(pay)"
          #panel
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="line-clamp-2 text-sm md:text-base">
                {{ pay.category | uppercase }} - {{ pay.name | uppercase }} -
                {{ pay.tag | uppercase }} - {{ pay.term | uppercase }}
              </span>
              <span
                *ngIf="pay.amount_remaining <= 0 && pay.total_amount > 0"
                class="ml-3 badge badge-success"
                >PAID</span
              >
            </mat-panel-title>
          </mat-expansion-panel-header>

          Total Amount to be paid: <b>{{ pay.total_amount }}</b> | Total Amount
          paid: <b>{{ pay.total_paid }}</b> <br />
          Total Amount remaining: <b>{{ pay.amount_remaining }}</b> <br />

          <div *ngIf="pay.amount_remaining < 0 && !recipient">
            <mat-form-field appearance="outline" class="w-50 mr-3">
              <input
                matInput
                [(ngModel)]="student_id"
                placeholder="Enter Student ID of the recipient"
                (ngModelChange)="checkIfSelf()"
              />
            </mat-form-field>
            <button
              mat-raised-button
              color="primary"
              (click)="transferPayment()"
            >
              Transfer Excess
            </button>
            <p class="text-danger">{{ message }}</p>
          </div>
          <div *ngIf="recipient">
            <b
              >{{ recipient.lastname | uppercase }}
              {{ recipient.firstname | uppercase }}
              {{ recipient.middlename | uppercase }}</b
            >
            <br />

            <app-custom-field
              label="Invoice"
              name="invoice"
              *ngIf="transferToSelf"
            >
              <mat-select
                name="invoice"
                [(ngModel)]="selectedInvoiceId"
                required
                [disabled]="filterInvoice.length === 0"
                placeholder="Select invoice to credit"
              >
                <mat-option
                  *ngFor="let invoice of filterInvoice"
                  [value]="invoice.invoice_id"
                >
                  {{ invoice.category }}- {{ invoice.name }} -
                  {{ invoice.tag }} - {{ invoice.term }}
                </mat-option>
              </mat-select>
            </app-custom-field>

            <div
              *ngIf="
                transferToSelf && filterInvoice.length > 1 && !selectedInvoiceId
              "
              class="text-danger mt-1"
            >
              Please select the invoice to credit.
            </div>

            <!-- <app-custom-field label="Invoice" name="invoice" >
                <mat-select name="gender" formControlName="gender">
                    <mat-option *ngFor="let gender of genders" [value]="gender.value">
                        {{ gender.value }}
                    </mat-option>
                </mat-select>
            </app-custom-field> -->

            <mat-form-field appearance="outline" class="w-50 mr-3">
              <input
                type="text"
                matInput
                [(ngModel)]="amount"
                placeholder="Enter Amount to transfer"
              />
            </mat-form-field>
            <button
              mat-raised-button
              color="warn"
              [disabled]="
                transferToSelf && filterInvoice.length > 1 && !selectedInvoiceId
              "
              (click)="confirmTransfer(pay, panel)"
            >
              Confirm Transfer
            </button>
            <p class="text-danger">{{ message }}</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
